export default "/images/framework/DownloadCht.1303c6f6.svg?1303c6f6";